import React from 'react'
import { useStoreState } from 'easy-peasy'
import ReactMarkdown from 'react-markdown'

import isDev from './isDev'

export function useTranslations(id, params = {}) {
  const t = useStoreState(state => state.locale.t)

  if (id === undefined) {
    // console.log(
    //   '%cTranslation error: id is required in Text Component',
    //   'color: red',
    // )
    return null
  }

  return t(id, params)
}

export default function Text({
  id,
  markdown = false,
  linkTarget,
  ...rest
}) {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const text = id !== 'not-show' ? useTranslations(id) : 'not-show'

  const stylesFail = {
    backgroundColor: '#ff00004f',
    display: 'inline-block',
  }
  const stylesDone = {
    backgroundColor: 'rgba(189, 255, 123, 0.5)',
    display: 'inline-block',
  }

  if (text === null) {
    const response = markdown ? (
      <ReactMarkdown
        /* eslint-disable-next-line react/jsx-props-no-spreading */
        {...rest}
        source={id}
        linkTarget={linkTarget}
        className="text-util"
      />
    ) : (
      id
    )
    if (isDev) return <span style={stylesFail}>{response}</span>
    return null
  }

  if (text === 'not-show') {
    return null
  }

  const response = markdown ? (
    <ReactMarkdown
      /* eslint-disable-next-line react/jsx-props-no-spreading */
      {...rest}
      source={text}
      linkTarget={linkTarget}
      className="text-util"
    />
  ) : (
    text
  )

  if (isDev)
    return (
      /* eslint-disable-next-line react/jsx-props-no-spreading */
      <span {...rest} style={stylesDone}>
        {response}
      </span>
    )
  return <span>{response}</span>
}
